module.exports = __webpack_public_path__ + "img/mtrial-readme.a54ce69.png";